import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, Table, TableBody, TableRow, TableCell } from '@mui/material';
import { selectEventReferenceDialogData } from 'main/store/schedule/selectors';
import { actions } from 'main/store/schedule/reducer';

export const EventReferenceDialog = () => {
    const dispatch = useDispatch();
    const dialogData = useSelector(selectEventReferenceDialogData);

    const handleClose = useCallback(() => {
        dispatch(actions.closeEventDialog());
    }, [dispatch]);

    return dialogData && (
        <Dialog open onClose={handleClose} fullWidth>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>日付</TableCell>
                        <TableCell>{dialogData.date}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>内容</TableCell>
                        <TableCell>{dialogData.content}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>時間</TableCell>
                        <TableCell>{dialogData.time}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>場所</TableCell>
                        <TableCell>{dialogData.place}</TableCell>
                    </TableRow>
                    {dialogData.description && <TableRow>
                        <TableCell sx={{ width: 64 }}>詳細</TableCell>
                        <TableCell>
                            {dialogData.description}
                        </TableCell>
                    </TableRow>}
                </TableBody>
            </Table>
        </Dialog>
    )
}
